import gql from "graphql-tag";

export const companyFragment = gql`
    fragment companyFragment on Company {
        id
        name
        contact_email
        label
        primary_phone
        secondary_phone
        fax
        street
        town
        state
        country
        zipcode
        website
        isMainCompany
        deleted_at
        categories {
            id
            name
            label
            color
        }
    }
`